export default __webpack_public_path__ + "static/media/office_2.6d8647e4.jpeg";